module.exports = __webpack_public_path__ + "static/fun-time/audio/karta1//4_Lisa.mp3";